import React, {useEffect, useState} from "react"
import {useParams} from "react-router-dom"

import {IGamePlay} from "@backend/types"

export default function GamePlayResults() {
    const {gamePlayId} = useParams()
    const [gamePlay, setGamePlay] = useState<IGamePlay>()

    useEffect(() => {


    }, [])

    // if (!gamePlay)
    //     return <Loading/>

    return <div>Your votes will be here</div>
}